import { Component, OnInit } from '@angular/core';
import { ComponentView } from '../ComponentView';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent extends ComponentView implements OnInit {

  constructor() { 
    super()
  }

  ngOnInit(): void {

    this.onCreated();
  }

}
